import React, { useState, useEffect } from 'react';
import Layout from '../components/layout/Layout/Layout';
import { apiBase } from '../services/api';

const MES_LABELS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const VialidadReportPage = () => {
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [tramo, setTramo] = useState('');
  const [anioOptions, setAnioOptions] = useState([]);
  const [tramoOptions, setTramoOptions] = useState([]);
  const [reportError, setReportError] = useState('');
  const [reportLoading, setReportLoading] = useState(false);
  const [optionsLoading, setOptionsLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiBase}/api/questions/reports/options`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error(`Error ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setAnioOptions(data.anios || []);
        setTramoOptions(data.tramos || []);
        if (data.anios?.length) setAnio(data.anios[0]);
        if (data.tramos?.length) setTramo(data.tramos[0]);
      })
      .catch(() => setReportError('No se pudieron cargar las opciones del formulario.'))
      .finally(() => setOptionsLoading(false));
  }, []);

  const handleGenerateVialidadReport = async () => {
    setReportLoading(true);
    setReportError('');
    try {
      const params = new URLSearchParams({ anio, mes, tramo });
      const url = `${apiBase}/api/questions/reports?${params}`;
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        let message = `Error ${response.status}`;
        try {
          const data = await response.json();
          if (data && data.error) {
            message = data.error;
            if (data.code === 'NO_EXCEL_FOR_PERIOD') {
              message = 'No hay un Excel configurado para el período seleccionado.';
            }
          }
        } catch {
          const text = await response.text();
          if (text) {
            message = text;
          }
        }
        throw new Error(message);
      }

      const mesLabel = MES_LABELS[mes - 1] || mes;
      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);
      try {
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `reporte_vialidad_${mesLabel}_${anio}_${tramo.replace(/\s+/g, '_')}.docx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } finally {
        URL.revokeObjectURL(downloadUrl);
      }
    } catch (err) {
      console.error('Error descargando informe de vialidad:', err);
      setReportError(
        err && err.message
          ? err.message
          : 'Error al generar/descargar el informe de vialidad.'
      );
    } finally {
      setReportLoading(false);
    }
  };

  return (
    <Layout>
      <div className="dashboard-container">
        <div className="container">
          <div className="dashboard-header">
            <div>
              <h1>Informe de Vialidad</h1>
              <p>Seleccioná año, mes y tramo para generar el informe.</p>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', maxWidth: '600px', marginTop: '24px' }}>
            <div className="form-group" style={{ flex: 1, minWidth: '140px' }}>
              <label htmlFor="report-anio">Año</label>
              <select
                id="report-anio"
                className="form-control"
                value={anio}
                onChange={(e) => setAnio(Number(e.target.value))}
                disabled={reportLoading || optionsLoading}
              >
                {anioOptions.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ flex: 1, minWidth: '160px' }}>
              <label htmlFor="report-mes">Mes</label>
              <select
                id="report-mes"
                className="form-control"
                value={mes}
                onChange={(e) => setMes(Number(e.target.value))}
                disabled={reportLoading || optionsLoading}
              >
                {MES_LABELS.map((label, i) => (
                  <option key={i + 1} value={i + 1}>{label}</option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ flex: 1, minWidth: '160px' }}>
              <label htmlFor="report-tramo">Tramo</label>
              <select
                id="report-tramo"
                className="form-control"
                value={tramo}
                onChange={(e) => setTramo(e.target.value)}
                disabled={reportLoading || optionsLoading}
              >
                {tramoOptions.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
          </div>

          {reportError && (
            <p className="text-error" style={{ marginTop: '8px' }}>
              {reportError}
            </p>
          )}

          <div style={{ marginTop: '12px' }}>
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleGenerateVialidadReport}
              disabled={reportLoading}
            >
              {reportLoading ? 'Generando...' : 'Generar informe'}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VialidadReportPage;
